import { AxiosResponse } from 'axios';
import qs from 'qs';
import { Equipment, SelectItem } from '~/types';
import api from '~/utils/api';
import { InsuranceList, InsuranceView } from '~/types/insurance';
import { formatInTimeZone } from '~/utils/formatToTimeZone';

export async function getInsuranceEquipaments(
  id: number,
): Promise<Equipment[]> {
  const { data } = await api.get<Equipment[]>(
    `/contrato_apolices/${id}/list_equipamentos`,
  );

  return data;
}

export async function getInsuranceList(id: number): Promise<InsuranceView[]> {
  const { data } = await api.get<InsuranceView[]>(
    `/contrato_apolices/${id}/list_apolices`,
  );

  const formattedData = data.map(insurance => ({
    ...insurance,
    formattedStartDate: insurance.dt_inicio
      ? formatInTimeZone(`${insurance.dt_inicio}`, 'dd/MM/yyyy')
      : '-',
    formattedEndDate: insurance.dt_encerramento
      ? formatInTimeZone(`${insurance.dt_encerramento}`, 'dd/MM/yyyy')
      : '-',
    formattedRenewalLimit: insurance.dt_limite_renovacao
      ? formatInTimeZone(`${insurance.dt_limite_renovacao}`, 'dd/MM/yyyy')
      : '-',
    formattedStatus:
      insurance.status === 0
        ? insurance.dias_vencimento === 0
          ? 'VENCE HOJE'
          : `VENCE EM ${insurance.dias_vencimento} ${
              insurance.dias_vencimento > 1 ? 'DIAS' : 'DIA'
            }`
        : insurance.status === 1
        ? 'VIGENTE'
        : 'ENCERRADA',
    statusColor:
      insurance.status === 0
        ? 'purple'
        : insurance.status === 1
        ? 'green'
        : 'red',
  }));

  return formattedData;
}

export async function getAllInsurance(): Promise<InsuranceView[]> {
  const { data } = await api.get<InsuranceView[]>(`/apolices`);

  const formattedData = data.map(insurance => ({
    ...insurance,
    formattedStartDate: insurance.dt_inicio
      ? formatInTimeZone(`${insurance.dt_inicio}`, 'dd/MM/yyyy')
      : '-',
    formattedEndDate: insurance.dt_encerramento
      ? formatInTimeZone(`${insurance.dt_encerramento}`, 'dd/MM/yyyy')
      : '-',
    formattedRenewalLimit: insurance.dt_limite_renovacao
      ? formatInTimeZone(`${insurance.dt_limite_renovacao}`, 'dd/MM/yyyy')
      : '-',
    formattedStatus:
      insurance.status === 0
        ? insurance.dias_vencimento === 0
          ? 'VENCE HOJE'
          : `VENCE EM ${insurance.dias_vencimento} ${
              insurance.dias_vencimento > 1 ? 'DIAS' : 'DIA'
            }`
        : insurance.status === 1
        ? 'VIGENTE'
        : 'ENCERRADA',
    statusColor:
      insurance.status === 0
        ? 'purple'
        : insurance.status === 1
        ? 'green'
        : 'red',
  }));

  return formattedData;
}

export async function getInsuranceDocument(
  id: number,
): Promise<AxiosResponse<any>> {
  const url = `/apolices/${id}/download`;
  return api.get(url, {
    headers: {
      'Content-Type': 'application/pdf',
    },
    responseType: 'blob' as 'json',
  });
}

export async function getInsuranceXlsx(
  groups: SelectItem[],
  st_seguro: string,
  periodo_inicial?: Date,
  periodo_final?: Date,
): Promise<AxiosResponse<any>> {
  const url = '/contrato_apolices/xlsx';
  const groupsIds = groups?.map(e => e.value);
  return api.get(url, {
    params: {
      ...(st_seguro && { status: st_seguro }),
      ...(groupsIds && { groups: groupsIds }),
      ...(periodo_inicial && {
        periodo_inicial: periodo_inicial.toISOString().substring(0, 10),
      }),
      ...(periodo_final && {
        periodo_final: periodo_final.toISOString().substring(0, 10),
      }),
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    headers: {
      'Content-Type': 'application/xlsx',
    },
    responseType: 'blob' as 'json',
  });
}

export async function getInsurances(
  groups: SelectItem[],
  st_seguro: string,
  periodo_inicial?: Date,
  periodo_final?: Date,
): Promise<InsuranceList[]> {
  const url = '/contrato_apolices/relatorio';
  const groupsIds = groups?.map(e => e.value);
  const { data } = await api.get<InsuranceList[]>(url, {
    params: {
      ...(st_seguro && { status: st_seguro }),
      ...(groupsIds && { groups: groupsIds }),
      ...(periodo_inicial && {
        periodo_inicial: periodo_inicial.toISOString().substring(0, 10),
      }),
      ...(periodo_final && {
        periodo_final: periodo_final.toISOString().substring(0, 10),
      }),
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });

  const formattedData = data.map(insurance => ({
    ...insurance,
    formattedStartDate: insurance.dt_inicio
      ? formatInTimeZone(`${insurance.dt_inicio}`, 'dd/MM/yyyy')
      : '-',
    formattedEndDate: insurance.dt_encerramento
      ? formatInTimeZone(`${insurance.dt_encerramento}`, 'dd/MM/yyyy')
      : '-',
    formattedRenewalLimit: insurance.dt_limite_renovacao
      ? formatInTimeZone(`${insurance.dt_limite_renovacao}`, 'dd/MM/yyyy')
      : '-',
    formattedStatus:
      insurance.status === 0
        ? insurance.dias_vencimento === 0
          ? 'VENCE HOJE'
          : `VENCE EM ${insurance.dias_vencimento} ${
              insurance.dias_vencimento > 1 ? 'DIAS' : 'DIA'
            }`
        : insurance.status === 1
        ? 'VIGENTE'
        : 'ENCERRADA',
    statusColor:
      insurance.status === 0
        ? 'purple'
        : insurance.status === 1
        ? 'green'
        : 'red',
  }));
  return formattedData;
}
